import loyaltyPointsList from './loyaltyPointsList.js';
import loyaltyPointsEdit from './loyaltyPointsEdit.js';
import loyaltyPointsImport from './loyaltyPointsImport.js';


export default {
    list: loyaltyPointsList,
    edit: loyaltyPointsEdit,
    create: loyaltyPointsImport
}